import { css } from 'lit';

export const styles = css`:host{--elevation: var(--ig-badge-elevation, var(--ig-elevation-0));--background-color: var(--ig-badge-background-color, var(--ig-primary-400));--ig-theme: indigo}`;
